var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-common-layout page" }, [
    _c("div", { staticClass: "jp-common-layout-left" }, [
      _c(
        "div",
        { staticClass: "jp-common-title" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入关键字进行过滤", size: "small" },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-button", {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                      circle: "",
                    },
                    on: { click: _vm.addTreeNode },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" }, [
        _c("div", { staticClass: "el-scrollbar__wrap" }, [
          _c(
            "div",
            { staticClass: "el-scrollbar__view" },
            [
              _c("el-tree", {
                ref: "formCategoryTree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.formCategoryTreeData,
                  props: {
                    value: "id", // ID字段名
                    label: "name", // 显示名称
                    children: "children", // 子级字段名
                  },
                  "default-expand-all": "",
                  "filter-node-method": _vm.filterNode,
                  "expand-on-click-node": false,
                  "highlight-current": "",
                  "node-key": "id",
                },
                on: { "node-click": _vm.handleNodeClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("span", { staticClass: "custom-tree-node" }, [
                        _c("span", [_vm._v(_vm._s(node.label))]),
                        _c(
                          "span",
                          [
                            _c("el-button", {
                              staticClass: "tree-item-button",
                              attrs: { type: "text", icon: "el-icon-plus" },
                              on: {
                                click: function () {
                                  return _vm.addChildTreeNode(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              staticClass: "tree-item-button",
                              attrs: {
                                type: "text",
                                icon: "el-icon-edit-outline",
                              },
                              on: {
                                click: function () {
                                  return _vm.editTreeNode(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              staticClass: "tree-item-button",
                              attrs: { type: "text", icon: "el-icon-delete" },
                              on: {
                                click: function () {
                                  return _vm.delTreeNode(data)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "jp-common-layout-center jp-flex-main" },
      [
        _c(
          "el-form",
          {
            ref: "searchForm",
            staticClass: "query-form",
            attrs: { size: "small", inline: true, model: _vm.searchForm },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.refreshList()
              },
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "category.id" } },
              [
                _c("SelectTree", {
                  ref: "category",
                  attrs: {
                    props: {
                      value: "id", // ID字段名
                      label: "name", // 显示名称
                      children: "children", // 子级字段名
                    },
                    size: "small",
                    url: "/extension/formCategory/treeData",
                    value: _vm.searchForm.category.id,
                    clearable: true,
                    accordion: true,
                  },
                  on: {
                    getValue: function (value) {
                      _vm.searchForm.category.id = value
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "name" } },
              [
                _c("el-input", {
                  attrs: {
                    size: "small",
                    placeholder: "表单名称",
                    clearable: "",
                  },
                  model: {
                    value: _vm.searchForm.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "name", $$v)
                    },
                    expression: "searchForm.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-search",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refreshList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", icon: "el-icon-refresh-right" },
                    on: {
                      click: function ($event) {
                        return _vm.resetSearch()
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "top bg-white" },
          [
            _c("vxe-toolbar", {
              attrs: {
                refresh: { query: _vm.refreshList },
                export: "",
                print: "",
                custom: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _vm.hasPermission("extension:formDefinition:add")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.add()
                                },
                              },
                            },
                            [_vm._v("新建")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("extension:formDefinition:edit")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "warning",
                                size: "small",
                                icon: "el-icon-edit-outline",
                                disabled:
                                  _vm.$refs.formDefinitionTable &&
                                  _vm.$refs.formDefinitionTable.getCheckboxRecords()
                                    .length !== 1,
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.edit()
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("extension:formDefinition:del")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "small",
                                icon: "el-icon-delete",
                                disabled:
                                  _vm.$refs.formDefinitionTable &&
                                  _vm.$refs.formDefinitionTable.getCheckboxRecords()
                                    .length === 0,
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.del()
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "div",
              { staticStyle: { height: "calc(100% - 80px)" } },
              [
                _c(
                  "vxe-table",
                  {
                    ref: "formDefinitionTable",
                    attrs: {
                      border: "inner",
                      "auto-resize": "",
                      resizable: "",
                      height: "auto",
                      loading: _vm.loading,
                      size: "small",
                      "show-header-overflow": "",
                      "show-overflow": "",
                      "highlight-hover-row": "",
                      "menu-config": {},
                      "print-config": {},
                      "import-config": {},
                      "export-config": {},
                      "sort-config": { remote: true },
                      data: _vm.dataList,
                      "checkbox-config": {},
                    },
                    on: { "sort-change": _vm.sortChangeHandle },
                  },
                  [
                    _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                    _c("vxe-column", {
                      attrs: { type: "checkbox", width: "40px" },
                    }),
                    _c("vxe-column", {
                      attrs: { title: "表单名称", field: "name", sortable: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("extension:formDefinition:edit")
                                ? _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  )
                                : _vm.hasPermission(
                                    "extension:formDefinition:view"
                                  )
                                ? _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.view(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  )
                                : _c("span", [_vm._v(_vm._s(scope.row.name))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "分类",
                        field: "category.name",
                        "sort-by": "b.name",
                        sortable: "",
                      },
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "版本号",
                        field: "formDefinitionJson.version",
                        "sort-by": "c.version",
                        sortable: "",
                      },
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "状态",
                        field: "formDefinitionJson.status",
                        "sort-by": "c.status",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.formDefinitionJson.status === "1"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "success" },
                                    },
                                    [_vm._v("已发布")]
                                  )
                                : _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                    },
                                    [_vm._v("未发布")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "是否主版本",
                        field: "formDefinitionJson.isPrimary",
                        "sort-by": "c.is_primary",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.formDefinitionJson.isPrimary === "1"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "success" },
                                    },
                                    [_vm._v("主版本")]
                                  )
                                : _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                    },
                                    [_vm._v("非主版本")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "操作",
                        width: "300px",
                        fixed: "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("extension:formDefinition:view")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-view",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDesignForm(
                                            scope.row.id,
                                            scope.row.formDefinitionJson.id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("设计")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("extension:formDefinition:edit")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-edit",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("extension:formDefinition:edit")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-edit",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.manage(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("版本管理")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("extension:formDefinition:del")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-delete",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.del(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("vxe-pager", {
              attrs: {
                background: "",
                size: "small",
                "current-page": _vm.tablePage.currentPage,
                "page-size": _vm.tablePage.pageSize,
                total: _vm.tablePage.total,
                "page-sizes": [
                  10,
                  20,
                  100,
                  1000,
                  { label: "全量数据", value: 1000000 },
                ],
                layouts: [
                  "PrevPage",
                  "JumpNumber",
                  "NextPage",
                  "FullJump",
                  "Sizes",
                  "Total",
                ],
              },
              on: { "page-change": _vm.currentChangeHandle },
            }),
          ],
          1
        ),
        _c("FormDefinitionForm", {
          ref: "formDefinitionForm",
          on: {
            showDesignForm: _vm.showDesignForm,
            refreshDataList: _vm.refreshList,
          },
        }),
        _c("FormCategoryForm", {
          ref: "formCategoryForm",
          on: { refreshTree: _vm.refreshTree },
        }),
        _c("DesignForm", {
          ref: "designForm",
          on: { refreshDataList: _vm.refreshList },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }